module.exports = __webpack_public_path__ + "img/2.cb0625ca.png";